import {IconButton, Image, Typography} from '@yandex-delivery/blocks'
import React, {memo} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {tagToUrl} from '../../lib/tagToUrl'
import type {CounterWidgetProps as Props} from '../types'
import * as classes from './classes'
import type {CounterProps} from './types'

export const CounterWidgetUI: React.FC<CounterProps> = props => {
  const {options, currentOption, value, handleChange} = props

  return (
    <div className={classes.counter}>
      <IconButton
        disabled={options[0].value !== undefined && options[0].value === value}
        onPress={() => {
          handleChange('down')
        }}
        size="s"
        variant="ghost"
      >
        <Image className={classes.button} src={tagToUrl('delivery_order_form_minus_icon')} />
      </IconButton>
      <Typography group="tight" thickness="bold" variant="caption1">
        {currentOption?.title}
      </Typography>
      <IconButton
        disabled={options.at(-1)?.value !== undefined && options.at(-1)?.value === value}
        onPress={() => {
          handleChange('up')
        }}
        size="s"
        variant="ghost"
      >
        <Image className={classes.button} src={tagToUrl('delivery_order_form_plus_icon')} />
      </IconButton>
    </div>
  )
}

export const CounterWidget = memo<Props>(({config: props}) => {
  const {options, form_state_key} = props.action
  const defaultOption = options.find(option => option.default)
  const {control} = useFormContext()
  const {
    field: {onChange, value},
  } = useController({name: form_state_key, control, defaultValue: defaultOption?.value || 120})
  const currentOption = options.find(option => option.value === value) || defaultOption

  function handleChange(direction: 'up' | 'down'): void {
    const currentIndex = currentOption ? options.indexOf(currentOption) : 0
    const newOption = direction === 'up' ? options[currentIndex + 1] : options[currentIndex - 1]
    onChange(newOption?.value)
  }

  return <CounterWidgetUI currentOption={currentOption} handleChange={handleChange} options={options} value={value} />
})

CounterWidget.displayName = 'Counter'
